import { IWixStyleFont } from '@wix/tpa-settings';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../components/FaqOoi/stylesParams';
import design from '../design';
import {
  getHtmlTagFromPreset,
  QuestionHtmlTag,
} from '../utils/getHtmlTagFromPreset';

// In Wix Studio (editor3), the font-style param the SDK returns is the
// builder-font shape from `@wix/document-services-types` (BuilderFontStyleParam),
// which exposes `cssVarName` (e.g. "wst-heading-3-font"). The classic
// `IWixStyleFont` doesn't declare it, so we widen the type here.
type StudioFont = IWixStyleFont & { cssVarName?: string };

// Resolution rules:
//   1. If the user picked an explicit SEO tag in the font picker, the font's
//      `preset` becomes "Custom" and `font.htmlTag` holds their choice.
//      → return `font.htmlTag`.
//   2. Otherwise derive the tag from the current preset (classic editor) or
//      cssVarName (Wix Studio) so that changing the preset updates the
//      rendered tag.
//   3. Fall back to the design default when the preset is unmapped.
export const useQuestionHtmlTag = (): QuestionHtmlTag => {
  const styles = useStyles();
  const questionTextFont = styles.get?.(stylesParams.questionTextFont) as
    | StudioFont
    | undefined;

  return getHtmlTagFromPreset(
    questionTextFont?.htmlTag,
    questionTextFont?.preset ?? questionTextFont?.cssVarName,
    design.questionText.font.htmlTag as QuestionHtmlTag,
  );
};
